// extracted by mini-css-extract-plugin
export default {"countdown-expired":"countdown-timer_countdown-expired__Cf3nT"};